<template>
  <div class="page-container appointment-attendance-page">
    <portal to="page-name">Atendimentos</portal>
    <div class="card card-page">
      <div class="card-header">
        <h1 class="card-title">Atendimentos</h1>
      </div>
      <div class="card-body">
        <div class="cr-toolbar at-toolbar">
          <div class="cr-toolbar-field at-field-period form-group">
            <label class="form-label">Período</label>
            <st-date-period
              :start-date.sync="filters.startDate"
              :end-date.sync="filters.endDate"
              :start-date-validator="$v.filters.startDate"
              :end-date-validator="$v.filters.endDate"
              :max-months="3"
              @blur:startDate="$v.filters.startDate.$touch()"
              @blur:endDate="$v.filters.endDate.$touch()"
            />
          </div>

          <div class="cr-toolbar-field form-group">
            <label for="filter-covenant" class="form-label">Convênio</label>
            <select id="filter-covenant" class="form-select"
                    v-model="filters.insurancePlanId">
              <option value="">Todos os convênios</option>
              <option v-for="(item, i) in insurances"
                      :value="item.plan.id" :key="i">{{ item.customName }}</option>
            </select>
          </div>

          <div class="cr-toolbar-field form-group">
            <label class="form-label">Tipo de plano</label>
            <select id="filter-plan-type" class="form-select" v-model="filters.planType">
              <option value="">Todos os planos</option>
              <option v-for="(text, value) in planTypes" :value="value" :key="value">
                {{ text }}
              </option>
            </select>
          </div>

          <div class="cr-toolbar-field form-group">
            <label for="filter-professional" class="form-label">Profissional</label>
            <select id="filter-professional" class="form-select"
                    v-model="filters.professionalId">
              <option value="">Todos os profissionais</option>
              <option v-for="(professional, i) in professionals" :key="i"
                      :value="professional.id">{{ professional.name }}</option>
            </select>
          </div>

          <div class="cr-toolbar-field form-group">
            <label for="filter-status" class="form-label">Status</label>
            <st-multi-select
              :items="statuses"
              label-key="name"
              value-key="key"
              v-model="filters.statuses"
              :show-toggle-all="true"
              class="multi-select"
            />
          </div>

          <div class="cr-toolbar-field form-group">
            <label class="form-label">Tipo do serviço</label>
            <select id="filter-schedule-types" class="form-select"
                    v-model="filters.expenseType">
              <option value="">Todos os tipos</option>
              <option v-for="(text, value) in types" :value="value" :key="value">
                {{ text }}
              </option>
            </select>
          </div>

          <div class="cr-toolbar-field form-group">
            <label class="form-label">Guia gerada</label>
            <select id="filter-has-account" class="form-select"
                    v-model="filters.hasAccount">
              <option value="">Todos</option>
              <option value="false">Não</option>
              <option value="true">Sim</option>
            </select>
          </div>

          <div class="cr-toolbar-field form-group">
            <label class="form-label">Retorno</label>
            <select class="form-select" v-model="filters.return">
              <option value="">Todos</option>
              <option value="false">Não</option>
              <option value="true">Sim</option>
            </select>
          </div>

          <div class="cr-toolbar-field form-group">
            <label class="form-label">Local</label>
            <select class="form-select" v-model="filters.placeId">
              <option value="">Todos os locais</option>
              <option v-for="place in places" :value="place.id" :key="place.id">
                {{ place.name }}
              </option>
            </select>
          </div>

          <div class="cr-toolbar-field at-field-patient form-group">
            <label class="form-label" for="filter-patient">Paciente</label>
            <input type="text" id="filter-patient" name="filter-patient"
                   v-model="filters.patient" class="form-input"
                   placeholder="Nome do paciente" @keypress.enter="load">
          </div>

          <div class="cr-toolbar-actions at-field-actions">
            <button class="btn btn-link btn-sm at-clear" @click="clearFilters">
              Limpar filtros
            </button>
            <button class="btn btn-gray btn-icon btn-icon-left"
                    :class="{loading: printing}" :disabled="printing" @click="print('sheet')">
              <fa-icon :icon="['fal', 'file-excel']"/>Excel
            </button>
            <button class="btn btn-gray btn-icon btn-icon-left"
                    :class="{loading: printing}" :disabled="printing" @click="print('pdf')">
              <fa-icon :icon="['fal', 'print']"/>Imprimir
            </button>
            <button class="btn btn-secondary btn-icon btn-icon-left"
                    :class="{loading}" :disabled="loading" @click="load">
              <fa-icon :icon="['fal', 'search']"/>Pesquisar
            </button>
          </div>
        </div>

        <div class="divider" />

<!--        <label class="form-switch form-group"-->
<!--               v-if="filters.professionalId && filters.hasAccount">-->
<!--          <input type="checkbox" v-model="filters.otherProfessional"/>-->
<!--          <i class="form-icon"/>Atendimento faturado para outro profissional-->
<!--        </label>-->
        <div class="loading loading-lg mt-2" v-if="loading" />
        <template v-else>
          <template v-if="data.items.length === 0">
            <div class="empty mt-2">
              <div class="empty-icon">
                <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
              </div>
              <p class="empty-title h5">Atendimentos</p>
              <p class="empty-subtitle">
                Nenhum atendimento encontrado. Verifique os filtros para realizar novas buscas
              </p>
            </div>
          </template>
          <template v-else>
            <table class="table table-striped table-hover">
              <thead>
              <tr>
                <th class="text-center">Status</th>
                <th style="width: 130px">Data e hora</th>
                <th>Paciente</th>
                <th class="hide-md hide-sm">Convênio</th>
                <th class="hide-md hide-sm">Agenda</th>
                <th class="hide-sm">Serviços</th>
                <th class="text-right">Total</th>
                <th class="text-right">Total Pago</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(appointment, i) in data.items" :key="i">
                <td class="text-center">
                  <span
                    class="tooltip appointment-status"
                    :data-tooltip="statusName(appointment.status)"
                    :style="statusStyle(appointment.status)"
                  />
                </td>
                <td>{{ appointment.startDate | date('datetime') }}</td>
                <td class="text-ellipsis" style="max-width: 180px">
                  {{ appointment.patientName }}
                </td>
                <td class="hide-md hide-sm text-ellipsis" style="max-width: 120px">
                  {{ appointment.insuranceName }}
                </td>
                <td class="hide-md hide-sm text-ellipsis" style="max-width: 120px">
                  {{ appointment.scheduleName }}
                </td>
                <td class="hide-sm">
                  <strong class="text-error" v-if="appointment.expenses.length === 0">
                    Nenhum serviço
                  </strong>
                  <template v-else>
                    <span
                      :class="hasNullService(appointment.expenses)
                       ? 'text-warning tooltip text-bold' : ''"
                      :data-tooltip="hasNullService ? 'Há serviço não precificado' : ''"
                    >
                      <strong class="text-info">
                        {{ appointment.expenses[0].return ? '[Retorno] ' : '' }}
                      </strong>
                      {{ appointment.expenses[0].name }}
                    </span>
                    <strong
                      v-if="appointment.expenses.length > 1"
                      class="label text-secondary tooltip ml-2"
                      :data-tooltip="appointment.expenses
                    .map((item) => `${item.return ? '[Retorno] ' : ''}${item.name}`)
                    .slice(1).join('\n')">
                     +{{ appointment.expenses.length -1 }}
                  </strong>
                  </template>
                </td>
                <td class="text-right">
                  <span
                    :class="totalExpense(appointment.expenses) === 0 ? 'text-error' : ''">
                    {{ totalExpense(appointment.expenses) | currency }}
                  </span>
                </td>
                <td class="text-right">
                  {{ appointment.totalPaid | currency }}
                </td>
                <td class="text-right">
                  <router-link
                    class="text-primary"
                    :to="appointmentLink(appointment.startDate, appointment.patientName)"
                    target="_blank"
                  >
                    <fa-icon :icon="['fal', 'external-link']" />
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
          </template>
        </template>
      </div>
      <div class="card-body text-right">
        <div class="attendance-summary" v-if="data.items.length > 0">
          <span class="mr-2 ml-1">Agendamentos: {{ totalAppointments }}</span>|
          <span class="mr-2 ml-1">Serviços: {{ totalExpenses }}</span>|
          <span class="mr-2 ml-1">Serviços x qtde.: {{ totalExpenseQty }}</span>|
          <strong class="mr-2 ml-1">Total: {{ total | currency }}</strong>|
          <strong class="ml-1">Total Pago: {{ totalPaid | currency }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { types } from 'src/data/expense-types';
import { types as planTypes } from 'src/data/insurance-types';
import * as status from 'src/data/appointment-statuses';
// eslint-disable-next-line import/no-cycle
import * as professionalApi from '@/app/professional/api';
import { PRINT_ATTENDANCE_LIST } from '@/data/actions/modules/financial';
import { date } from '../../../../data/validators';
import formMixin from '../../../../mixins/form';

const STATUSES = status.statuses.filter(({ key }) => !['available', 'blocked'].includes(key));

export default {
  mixins: [formMixin],
  data() {
    return {
      types,
      planTypes,
      status,
      statuses: STATUSES,
      insurances: [],
      professionals: [],
      places: [],
      loading: false,
      printing: false,
      filters: {
        insurancePlanId: '',
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        hasAccount: '',
        planType: '',
        excludeLegacy: '',
        expenseType: '',
        placeId: '',
        professionalId: '',
        return: '',
        patient: '',
        statuses: STATUSES.map(({ key }) => key),
        // otherProfessional: false,
      },
      data: this.blankData(),
    };
  },
  mounted() {
    this.applyQuery();
    this.loadInsurances();
    this.loadProfessionals();
    this.loadPlaces();
    this.load();
  },
  validations() {
    return {
      filters: {
        startDate: { date, required },
        endDate: { date, required },
      },
    };
  },
  computed: {
    canAccessPrintAttendance() {
      if (PRINT_ATTENDANCE_LIST) {
        return this.$can(PRINT_ATTENDANCE_LIST);
      }
      return true;
    },
    totalAppointments() {
      return this.data.items.length;
    },
    totalExpenses() {
      return this.data.items.reduce((result, item) => result + item.expenses.length, 0);
    },
    totalExpenseQty() {
      return this.data.items.reduce((result, item) => {
        const expenseQty = item.expenses.reduce((a, b) => a + b.quantity, 0);
        return result + expenseQty;
      }, 0);
    },
    total() {
      return this.data.items.reduce((a, b) => a + b.total, 0);
    },
    totalPaid() {
      return this.data.items.reduce((a, b) => a + b.totalPaid, 0);
    },
  },
  methods: {
    clearFilters() {
      this.filters = {
        ...this.filters,
        insurancePlanId: '',
        planType: '',
        hasAccount: '',
        expenseType: '',
        placeId: '',
        professionalId: '',
        return: '',
        patient: '',
        statuses: STATUSES.map(({ key }) => key),
      };
      this.load();
    },
    applyQuery() {
      const query = this.$route.query || {};
      if (moment(query.startDate, 'YYYY-MM-DD', true).isValid()) {
        this.filters.startDate = String(query.startDate);
      }
      if (moment(query.endDate, 'YYYY-MM-DD', true).isValid()) {
        this.filters.endDate = String(query.endDate);
      }
      if (query.insurancePlanId) this.filters.insurancePlanId = String(query.insurancePlanId);
      if (query.hasAccount === 'false' || query.hasAccount === 'true') {
        this.filters.hasAccount = String(query.hasAccount);
      }
      if (planTypes[query.planType]) {
        this.filters.planType = String(query.planType);
      }
      if (query.excludeLegacy === 'true') {
        this.filters.excludeLegacy = 'true';
      }
      if (query.statuses) {
        const wanted = String(query.statuses).split(',');
        const allowed = STATUSES.map(({ key }) => key).filter(key => wanted.includes(key));
        if (allowed.length > 0) this.filters.statuses = allowed;
      }
    },
    getParams() {
      const params = {
        limit: this.data.limit,
        offset: this.data.offset,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        statuses: this.filters.statuses.join(','),
      };

      if (this.filters.insurancePlanId) {
        params.insurancePlanId = this.filters.insurancePlanId;
      }

      if (this.filters.hasAccount) {
        params.hasAccount = this.filters.hasAccount;
      }

      if (this.filters.planType) {
        params.planType = this.filters.planType;
      }

      if (this.filters.excludeLegacy) {
        params.excludeLegacy = this.filters.excludeLegacy;
      }

      if (this.filters.expenseType) {
        params.expenseType = this.filters.expenseType;
      }

      if (this.filters.placeId) {
        params.placeId = this.filters.placeId;
      }

      if (this.filters.professionalId) {
        params.professionalId = this.filters.professionalId;
      }

      if (this.filters.patient) {
        params.patient = this.filters.patient;
      }

      if (this.filters.return) {
        params.return = this.filters.return;
      }

      // if (this.filters.otherProfessional) {
      //   params.otherProfessional = this.filters.otherProfessional;
      // }

      return params;
    },
    load() {
      this.$v.filters.$touch();
      if (this.$v.filters.$error) {
        return;
      }

      const duration = moment.duration(moment(this.filters.endDate)
        .diff(moment(this.filters.startDate))).asMonths();

      if (duration > 3) {
        this.$toast.show('O intervalo entre as datas não pode ser superior a 3 meses!',
          { type: 'error' });
        return;
      }

      if (this.filters.statuses.length === 0) {
        this.$toast.show('Por favor, informe ao menos um status de agendamento',
          { type: 'error' });
        return;
      }

      this.data = this.blankData();

      const params = this.getParams();

      this.loading = true;

      this.$httpX.get('/appointment-attendances', { params })
        .then(({ data }) => {
          this.data = data;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadInsurances() {
      const params = {
        limit: 0,
        active: true,
      };
      return this.$http.get('/insurance-plans', { params })
        .then(({ data }) => {
          this.insurances = data.items;
        })
        .catch(() => {});
    },
    loadProfessionals() {
      return professionalApi.allActive()
        .then((data) => {
          this.professionals = data.items;
        })
        .catch(this.$toast.error);
    },
    loadPlaces() {
      const params = {
        limit: 0,
        type: 'clinical',
        active: true,
      };
      return this.$http.get('/places', { params })
        .then(({ data }) => {
          this.places = data.items;
        })
        .catch(this.$toast.error);
    },
    appointmentLink(startDate, patientName) {
      const appointmentDate = moment(startDate).format('YYYY-MM-DD');
      const name = encodeURIComponent(patientName);
      return `/appointments?date=${appointmentDate}&s=${name}&scheduleId=ALL`;
    },
    print(printType) {
      if (!this.canAccessPrintAttendance) {
        this.$toast.show('Acesso não autorizado!', { type: 'error' });
        return;
      }
      this.$v.filters.$touch();
      if (this.$v.filters.$error) {
        return;
      }

      this.printing = true;

      const params = this.getParams();

      params.printType = printType;

      if (printType === 'sheet') {
        this.$file
          .download('/reports/attendances', params, {
            method: 'POST',
            name: 'Relação de atendimentos.xlsx',
          })
          .catch(() => {})
          .finally(() => {
            this.printing = false;
          });
      } else {
        this.$file
          .print('/reports/attendances', params, { method: 'POST' })
          .catch(() => {})
          .finally(() => {
            this.printing = false;
          });
      }
    },
    statusColor(appointmentStatus) {
      return status.getColor(appointmentStatus);
    },
    statusName(appointmentStatus) {
      return status.getName(appointmentStatus);
    },
    statusStyle(appointmentStatus) {
      return {
        backgroundColor: this.statusColor(appointmentStatus),
        display: 'inline-block',
        width: '18px',
        height: '18px',
        borderRadius: '4px',
      };
    },
    hasNullService(expenses) {
      return expenses.filter(item => !item.return).some(({ total }) => total === 0);
    },
    totalExpense(expenses) {
      return expenses.reduce((a, b) => a + b.total, 0);
    },
    blankData() {
      return {
        items: [],
        hasMore: false,
        offset: 0,
        limit: 30,
      };
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/scss/variables";
@import '~assets/scss/mixins';

.appointment-attendance-page {
  .dropdown {
    display: block;
  }
  .cr-toolbar {
    align-items: start;
    background-color: $gray-color-ultra-light;
    border: $border-color solid $border-width;
    border-radius: $border-radius;
    display: grid;
    gap: $layout-spacing;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    margin-bottom: $layout-spacing-lg;
    padding: $layout-spacing;
    .form-group {
      margin-bottom: 0;
      min-width: 0;
    }
    .form-label {
      color: $gray-color-dark;
      font-size: $font-size-xs;
    }
    .at-field-period {
      grid-column: span 2;
    }
    .at-field-patient {
      grid-column: span 2;
    }
    .cr-toolbar-actions {
      align-items: center;
      display: flex;
      gap: $layout-spacing-sm;
      grid-column: 3 / -1;
      justify-content: flex-end;
      padding-top: $control-size - $layout-spacing;
      .at-clear {
        margin-right: auto;
      }
    }
  }
  @media screen and (max-width: $size-md) {
    .cr-toolbar {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      .at-field-period,
      .at-field-patient,
      .cr-toolbar-actions {
        grid-column: 1 / -1;
      }
    }
  }
  //.attendance-summary {
  //  background-color: $gray-color-ultra-light;
  //  border: $border-colodisplayr solid $border-width;
  //  border-radius: $border-radius;
  //  margin: $layout-spacing-sm 0 $layout-spacing 0;
  //  padding: $layout-spacing;
  //}
  //.attendance-items-title {
  //  border-bottom: $border-color solid $border-width;
  //  background-color: $gray-color-ultra-light;
  //  margin: 0 calc($layout-spacing-sm / 5);
  //  padding: $layout-spacing 0;
  //}
  //.status-group {
  //  border: $border-width solid $border-color;
  //  border-radius: $border-radius;
  //  margin-bottom: $layout-spacing;
  //  padding: $layout-spacing;
  //}
  //.footer {
  //  text-align: right;
  //}
}
</style>
